function initAbout() {
  const aboutMainSlider = document.querySelector('.about__main-slider');

  if (aboutMainSlider) {
    const aboutMainSliderSwiper = new Swiper(aboutMainSlider, {
      slidesPerView: 4,
      spaceBetween: 20,

      navigation: {
        nextEl: '.about__main-slider .swiper-navigation__btn--next',
      },

      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  }

  const aboutReviewsSlider = document.querySelector('.about__reviews-slider');

  if (aboutReviewsSlider) {
    const aboutReviewsSliderSwiper = new Swiper(aboutReviewsSlider, {
      slidesPerView: 3,
      spaceBetween: 20,

      navigation: {
        nextEl: '.about__reviews-slider .swiper-navigation__btn--next',
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  }
}

export { initAbout };
